(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[987],{

/***/ 2115:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
const React = __importStar(__webpack_require__(1720));
const SVGComponent = (props) => (React.createElement("svg", Object.assign({ width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.9796 19.9531H19.3997", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M21.8628 22.4146C23.2231 22.4146 24.3259 21.3118 24.3259 19.9514C24.3259 18.5911 23.2231 17.4883 21.8628 17.4883C20.5025 17.4883 19.3997 18.5911 19.3997 19.9514C19.3997 21.3118 20.5025 22.4146 21.8628 22.4146Z", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M9.51518 22.3678C10.8755 22.3678 11.9783 21.265 11.9783 19.9046C11.9783 18.5442 10.8755 17.4414 9.51518 17.4414C8.15484 17.4414 7.05206 18.5442 7.05206 19.9046C7.05206 21.265 8.15484 22.3678 9.51518 22.3678Z", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M6.62496 19.9524H5.66111C5.32997 19.9512 5.01063 19.8294 4.76282 19.6098C4.51501 19.3901 4.35574 19.0877 4.31481 18.7591L4.00881 15.7911C3.96946 15.4493 4.0567 15.1049 4.25402 14.823C4.45135 14.5411 4.74511 14.3412 5.07977 14.2612L5.98241 14.047C6.3972 13.9424 6.76083 13.6928 7.00744 13.3433L8.85864 10.7272C9.1596 10.2965 9.56024 9.94493 10.0264 9.70251C10.4926 9.4601 11.0105 9.33399 11.536 9.33498H16.1257C16.7491 9.3332 17.3663 9.45845 17.9398 9.70307C18.5132 9.94769 19.0307 10.3065 19.4609 10.7578L22.5207 14.0011L26.4067 14.7049C26.6696 14.7531 26.9197 14.8549 27.1415 15.0042C27.3632 15.1534 27.5518 15.3468 27.6954 15.5722C27.839 15.7977 27.9345 16.0503 27.976 16.3144C28.0175 16.5784 28.0041 16.8482 27.9366 17.1068L27.5694 18.6367C27.4705 19.0234 27.2451 19.3661 26.929 19.61C26.613 19.8539 26.2245 19.9852 25.8253 19.983H24.2036", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M22.5358 14.0169L6.42584 13.8945", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 })));
exports["default"] = SVGComponent;
//# sourceMappingURL=car.js.map

/***/ }),

/***/ 5593:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
const React = __importStar(__webpack_require__(1720));
const SVGComponent = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5.27L3.28 4L20 20.72L18.73 22L15.65 18.92C14.5 19.3 13.28 19.5 12 19.5C7 19.5 2.73 16.39 1 12C1.69 10.24 2.79 8.69 4.19 7.46L2 5.27ZM12 9C12.4801 8.99975 12.9532 9.11471 13.3796 9.33524C13.8061 9.55576 14.1733 9.8754 14.4506 10.2673C14.7279 10.6592 14.9071 11.1119 14.9731 11.5875C15.0391 12.063 14.99 12.5474 14.83 13L11 9.17C11.3213 9.05698 11.6594 8.99949 12 9ZM12 4.5C17 4.5 21.27 7.61 23 12C22.1839 14.0732 20.7969 15.8727 19 17.19L17.58 15.76C18.9629 14.8034 20.0782 13.5091 20.82 12C20.0116 10.3499 18.7564 8.95977 17.1973 7.9875C15.6381 7.01524 13.8375 6.49988 12 6.5C10.91 6.5 9.84 6.68 8.84 7L7.3 5.47C8.74 4.85 10.33 4.5 12 4.5ZM3.18 12C3.98844 13.6501 5.24357 15.0402 6.80273 16.0125C8.36189 16.9848 10.1625 17.5001 12 17.5C12.69 17.5 13.37 17.43 14 17.29L11.72 15C11.0242 14.9254 10.3748 14.6149 9.87997 14.12C9.38512 13.6252 9.07458 12.9758 9 12.28L5.6 8.87C4.61 9.72 3.78 10.78 3.18 12Z", fill: "#36354C" })));
exports["default"] = SVGComponent;
//# sourceMappingURL=hide-password.js.map

/***/ }),

/***/ 9129:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
const React = __importStar(__webpack_require__(1720));
const SVGComponent = (props) => (React.createElement("svg", Object.assign({ width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.9796 19.9531H19.3997", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M21.8628 22.4146C23.2231 22.4146 24.3259 21.3118 24.3259 19.9514C24.3259 18.5911 23.2231 17.4883 21.8628 17.4883C20.5025 17.4883 19.3997 18.5911 19.3997 19.9514C19.3997 21.3118 20.5025 22.4146 21.8628 22.4146Z", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M9.51518 22.3678C10.8755 22.3678 11.9783 21.265 11.9783 19.9046C11.9783 18.5442 10.8755 17.4414 9.51518 17.4414C8.15484 17.4414 7.05206 18.5442 7.05206 19.9046C7.05206 21.265 8.15484 22.3678 9.51518 22.3678Z", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M6.62496 19.9524H5.66111C5.32997 19.9512 5.01063 19.8294 4.76282 19.6098C4.51501 19.3901 4.35574 19.0877 4.31481 18.7591L4.00881 15.7911C3.96946 15.4493 4.0567 15.1049 4.25402 14.823C4.45135 14.5411 4.74511 14.3412 5.07977 14.2612L5.98241 14.047C6.3972 13.9424 6.76083 13.6928 7.00744 13.3433L8.85864 10.7272C9.1596 10.2965 9.56024 9.94493 10.0264 9.70251C10.4926 9.4601 11.0105 9.33399 11.536 9.33498H16.1257C16.7491 9.3332 17.3663 9.45845 17.9398 9.70307C18.5132 9.94769 19.0307 10.3065 19.4609 10.7578L22.5207 14.0011L26.4067 14.7049C26.6696 14.7531 26.9197 14.8549 27.1415 15.0042C27.3632 15.1534 27.5518 15.3468 27.6954 15.5722C27.839 15.7977 27.9345 16.0503 27.976 16.3144C28.0175 16.5784 28.0041 16.8482 27.9366 17.1068L27.5694 18.6367C27.4705 19.0234 27.2451 19.3661 26.929 19.61C26.613 19.8539 26.2245 19.9852 25.8253 19.983H24.2036", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 }),
    React.createElement("path", { d: "M22.5358 14.0169L6.42584 13.8945", stroke: "#5B5675", strokeWidth: 1.5, strokeMiterlimit: 10 })));
exports["default"] = SVGComponent;
//# sourceMappingURL=right-arrow.js.map

/***/ }),

/***/ 9706:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
const React = __importStar(__webpack_require__(1720));
const SVGComponent = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9V9ZM12 4.5C17 4.5 21.27 7.61 23 12C21.27 16.39 17 19.5 12 19.5C7 19.5 2.73 16.39 1 12C2.73 7.61 7 4.5 12 4.5ZM3.18 12C3.98825 13.6503 5.24331 15.0407 6.80248 16.0133C8.36165 16.9858 10.1624 17.5013 12 17.5013C13.8376 17.5013 15.6383 16.9858 17.1975 16.0133C18.7567 15.0407 20.0117 13.6503 20.82 12C20.0117 10.3497 18.7567 8.95925 17.1975 7.98675C15.6383 7.01424 13.8376 6.49868 12 6.49868C10.1624 6.49868 8.36165 7.01424 6.80248 7.98675C5.24331 8.95925 3.98825 10.3497 3.18 12V12Z", fill: "#36354C" })));
exports["default"] = SVGComponent;
//# sourceMappingURL=show-password.js.map

/***/ }),

/***/ 3282:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PhoneInput = exports.Toggle = exports.Radio = exports.Checkbox = exports.OTPInput = exports.PhoneEmailInput = exports.PasswordInput = exports.AdrillaInput = exports.Input = void 0;
const input_1 = __importDefault(__webpack_require__(3367));
Object.defineProperty(exports, "Input", ({ enumerable: true, get: function () { return input_1.default; } }));
const home_input_1 = __importDefault(__webpack_require__(3882));
Object.defineProperty(exports, "AdrillaInput", ({ enumerable: true, get: function () { return home_input_1.default; } }));
const password_1 = __importDefault(__webpack_require__(7961));
Object.defineProperty(exports, "PasswordInput", ({ enumerable: true, get: function () { return password_1.default; } }));
const phone_email_input_1 = __importDefault(__webpack_require__(319));
Object.defineProperty(exports, "PhoneEmailInput", ({ enumerable: true, get: function () { return phone_email_input_1.default; } }));
const otp_input_1 = __importDefault(__webpack_require__(573));
Object.defineProperty(exports, "OTPInput", ({ enumerable: true, get: function () { return otp_input_1.default; } }));
const checkbox_1 = __importDefault(__webpack_require__(7677));
Object.defineProperty(exports, "Checkbox", ({ enumerable: true, get: function () { return checkbox_1.default; } }));
const radio_1 = __importDefault(__webpack_require__(1969));
Object.defineProperty(exports, "Radio", ({ enumerable: true, get: function () { return radio_1.default; } }));
const toggle_1 = __importDefault(__webpack_require__(4592));
Object.defineProperty(exports, "Toggle", ({ enumerable: true, get: function () { return toggle_1.default; } }));
const phone_input_1 = __importDefault(__webpack_require__(4186));
Object.defineProperty(exports, "PhoneInput", ({ enumerable: true, get: function () { return phone_input_1.default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 8092:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(1720));
const classnames_1 = __importDefault(__webpack_require__(4184));
const input_styles_1 = __webpack_require__(9142);
const building_blocks_ui_theme_1 = __webpack_require__(549);
const InputComponent = (0, react_1.forwardRef)(({ type, className, value, onChange, onBlur, placeHolder = '', labelText, hasError, errMsg, leftElement, rightElement, disabled, style, hintText, isAdrillaInput, onfocus, disableCopy, disablePaste, onKeyUp, dataTestId, inputMode = 'text', pattern = '', }, ref) => {
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    const onCopy = (e) => {
        if (disableCopy) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            return false;
        }
    };
    const onPaste = (e) => {
        if (disablePaste) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            return false;
        }
    };
    return (react_1.default.createElement(input_styles_1.InputContainer, { className: className, style: style, theme: theme, colors: colors },
        react_1.default.createElement(input_styles_1.InputAndLabel, null,
            react_1.default.createElement(input_styles_1.InputElement, { ref: ref, className: `inputField ${(0, classnames_1.default)({
                    hasValue: value,
                    hasError: hasError,
                    hasLeftIcon: leftElement,
                    hasRightIcon: rightElement,
                })}`, type: type || 'text', value: value, onChange: onChange, onBlur: onBlur, placeholder: placeHolder, disabled: disabled, theme: theme, colors: colors, onFocus: onfocus, onCopy: onCopy, onPaste: onPaste, onKeyUp: onKeyUp, "data-testid": dataTestId, inputmode: inputMode, pattern: pattern }),
            labelText && (react_1.default.createElement(input_styles_1.InputLabel, { theme: theme, colors: colors, className: `${(0, classnames_1.default)({ shiftRight: leftElement })}` }, labelText)),
            leftElement && (react_1.default.createElement(input_styles_1.LeftIcon, { theme: theme, colors: colors }, leftElement)),
            rightElement && (react_1.default.createElement(input_styles_1.RightIcon, { className: `${(0, classnames_1.default)({ isAdrilla: isAdrillaInput })}`, theme: theme, colors: colors }, rightElement))),
        hasError && (react_1.default.createElement(input_styles_1.ErrorMessage, { theme: theme, colors: colors }, errMsg)),
        !hasError && hintText && (react_1.default.createElement(input_styles_1.HintText, { theme: theme, colors: colors }, hintText))));
});
exports["default"] = InputComponent;
//# sourceMappingURL=input.js.map

/***/ }),

/***/ 9142:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CountryCodeText = exports.HidePasswordIcon = exports.ShowPasswordIcon = exports.RightArrowIcon = exports.CarIcon = exports.SubmitButton = exports.HintText = exports.InputAndLabel = exports.RightIcon = exports.LeftIcon = exports.ErrorMessage = exports.InputLabel = exports.InputElement = exports.CheckBoxElement = exports.ToggleElement = exports.InputContainer = void 0;
const building_blocks_ui_common_1 = __webpack_require__(9749);
const car_1 = __importDefault(__webpack_require__(2115));
const right_arrow_1 = __importDefault(__webpack_require__(9129));
const show_password_1 = __importDefault(__webpack_require__(9706));
const hide_password_1 = __importDefault(__webpack_require__(5593));
const InputContainer = building_blocks_ui_common_1.styled.div `
  width: 100%;
  position: relative;
`;
exports.InputContainer = InputContainer;
const InputAndLabel = building_blocks_ui_common_1.styled.div `
  position: relative;
  width: 100%;
`;
exports.InputAndLabel = InputAndLabel;
const InputLabel = building_blocks_ui_common_1.styled.label `
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  line-height: ${(props) => props.theme.typography.lineHeights.C1};
  position: absolute;
  left: ${(props) => props.theme.spacing[3]};
  top: 50%;
  transform: translateY(-50%);
  color: ${(props) => props.colors.neutral.n400};
  background-color: ${(props) => props.colors.primary.n0};
  transition: all 0.15s ease-out 0s;
  pointer-events: none;
  &.shiftRight {
    left: ${(props) => props.theme.spacing[9]};
  }
  padding: 0 ${(props) => props.theme.spacing[1]};
`;
exports.InputLabel = InputLabel;
const InputElement = building_blocks_ui_common_1.styled.input `
  border-radius: ${(props) => props.theme.border.radius.large};
  padding: ${(props) => props.theme.spacing[3] + ' ' + props.theme.spacing[4]};
  font-weight: ${(props) => props.theme.typography.fonts.weight.P1};
  width: 100%;
  border: ${(props) => props.theme.border.width.thin} solid
    ${(props) => props.colors.neutral.n300};
  box-sizing: border-box;
  position: relative;
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  line-height: ${(props) => props.theme.typography.lineHeights.P2};
  &:focus {
    outline: none;
    border-color: ${(props) => props.colors.neutral.n400};
  }
  &:focus + label,
  &.hasValue + label {
    transform: translateY(-31px);
    font-size: ${(props) => props.theme.typography.fonts.size.P2};
  }
  &:focus.hasLeftIcon + label,
  &.hasValue.hasLeftIcon + label {
    transform: translateY(-31px) translateX(-34px);
  }
  &.hasLeftIcon {
    padding-left: ${(props) => props.theme.spacing[10]};
  }
  &.hasRightIcon {
    padding-right: ${(props) => props.theme.spacing[10]};
  }
  &:disabled {
    background: ${(props) => props.colors.neutral.n50};
    border: ${(props) => props.theme.border.width.none};
    color: #7a7690;
  }
  &:disabled + label {
    background-color: white;
  }
  &.hasError {
    border: ${(props) => props.theme.border.width.thin} solid
      ${(props) => props.colors.secondary.cg_red};
  }
  ::placeholder {
    color: ${(props) => props.colors.neutral.n400};
  }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
exports.InputElement = InputElement;
const InfoText = building_blocks_ui_common_1.styled.div `
  font-size: ${(props) => props.theme.typography.fonts.size.C1};
  line-height: ${(props) => props.theme.typography.lineHeights.C1};
  margin-top: ${(props) => props.theme.spacing[1]};
`;
const ErrorMessage = (0, building_blocks_ui_common_1.styled)(InfoText) `
  color: ${(props) => props.colors.secondary.cg_red};
`;
exports.ErrorMessage = ErrorMessage;
const HintText = (0, building_blocks_ui_common_1.styled)(InfoText) `
  color: ${(props) => props.colors.neutral.n400};
`;
exports.HintText = HintText;
const Icon = building_blocks_ui_common_1.styled.div `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;
const LeftIcon = (0, building_blocks_ui_common_1.styled)(Icon) `
  left: ${(props) => props.theme.spacing[4]};
  color: ${(props) => props.colors.primary.n600};
`;
exports.LeftIcon = LeftIcon;
const RightIcon = (0, building_blocks_ui_common_1.styled)(Icon) `
  right: ${(props) => props.theme.spacing[4]};
  color: ${(props) => props.colors.neutral.n400};

  &.isAdrilla {
    right: ${(props) => props.theme.spacing[2]};
  }
`;
exports.RightIcon = RightIcon;
//TODO: remove this when button component is available
const SubmitButton = building_blocks_ui_common_1.styled.button `
  background-color: ${(props) => props.colors.primary.g300};
  cursor: pointer;
  height: 44px;
  width: 44px;
  border-radius: ${(props) => props.theme.border.radius.large};
  color: ${(props) => props.colors.primary.n0};
  border: ${(props) => props.theme.border.width.none};
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;
exports.SubmitButton = SubmitButton;
const CarIcon = (0, building_blocks_ui_common_1.styled)(car_1.default) `
  width: 32px;
  height: 32px;
  margin-top: 3px;
`;
exports.CarIcon = CarIcon;
const RightArrowIcon = (0, building_blocks_ui_common_1.styled)(right_arrow_1.default) ``;
exports.RightArrowIcon = RightArrowIcon;
const HidePasswordIcon = (0, building_blocks_ui_common_1.styled)(hide_password_1.default) `
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
exports.HidePasswordIcon = HidePasswordIcon;
const ShowPasswordIcon = (0, building_blocks_ui_common_1.styled)(show_password_1.default) `
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
exports.ShowPasswordIcon = ShowPasswordIcon;
const CheckBoxElement = building_blocks_ui_common_1.styled.input `
  position: relative;
  display: block;
  width: ${(props) => props.dimension === 'small'
    ? props.theme.spacing[4]
    : props.theme.spacing[5]};
  height: ${(props) => props.dimension === 'small'
    ? props.theme.spacing[4]
    : props.theme.spacing[5]};
  border: ${(props) => props.theme.border.width.thin} solid
    ${(props) => props.colors.secondary.n300};
  border-radius: ${(props) => props.theme.border.radius.medium};
  box-sizing: border-box;
  &:disabled {
    background: ${(props) => props.colors.secondary.n50};
    border: ${(props) => props.theme.border.width.none};
    color: ${(props) => props.colors.secondary.n50};
  }
  &:disabled + label {
    background-color: white;
  }
  &.hasError {
    border: ${(props) => props.theme.border.width.thin} solid
      ${(props) => props.colors.secondary.cg_red};
  }
  :checked {
    accent-color: ${(props) => props.colors.primary.g300};
  }
`;
exports.CheckBoxElement = CheckBoxElement;
const ToggleElement = building_blocks_ui_common_1.styled.label `
  /* toggle in label designing */
  .toggle {
    position: relative;
    display: inline-block;
    width: ${(props) => props.theme.spacing[8]};
    height: ${(props) => props.theme.spacing[6]};
    border-radius: 30px;
    border: ${(props) => props.theme.border.radius.small} solid
      ${(props) => props.colors.secondary.n300};
    background: ${(props) => props.colors.secondary.n300};
  }

  /* After slide changes */
  .toggle:after {
    background: ${(props) => props.colors.primary.n0};
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15);
    transform: rotate(-180deg);
    content: '';
    position: absolute;
    width: ${(props) => props.theme.spacing[5]};
    height: ${(props) => props.theme.spacing[5]};
    border-radius: 50%;
    top: 2px;
    left: 1px;
    transition: all 0.5s;
  }

  /* Checkbox checked effect */
  .checkbox:checked + .toggle::after {
    left: 18px;
  }

  /* Checkbox checked toggle label bg color */
  .checkbox:checked + .toggle {
    border: ${(props) => props.theme.border.radius.small} solid
      ${(props) => props.colors.primary.g300};
    background-color: ${(props) => props.colors.primary.g300};
  }

  /* Checkbox vanished */
  .checkbox {
    display: none;
  }
`;
exports.ToggleElement = ToggleElement;
const CountryCodeText = building_blocks_ui_common_1.styled.div `
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  line-height: ${(props) => props.theme.typography.lineHeights.P1};
  font-weight: ${(props) => props.theme.typography.fonts.weight.P1};
  color: ${(props) => props.colors.primary.n600};
`;
exports.CountryCodeText = CountryCodeText;
//# sourceMappingURL=input.styles.js.map

/***/ }),

/***/ 1371:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
let timer;
function debounce(func, timeout = 300) {
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}
exports["default"] = debounce;
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 7677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_theme_1 = __webpack_require__(549);
const react_1 = __importDefault(__webpack_require__(1720));
const input_styles_1 = __webpack_require__(9142);
const Checkbox = (props) => {
    const { dimension = 'small', checked, onChange = () => { } } = props, restProps = __rest(props, ["dimension", "checked", "onChange"]);
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    return (react_1.default.createElement(input_styles_1.CheckBoxElement, Object.assign({ type: "checkbox", checked: checked, onClick: onChange, theme: theme, colors: colors, dimension: dimension }, restProps)));
};
exports["default"] = Checkbox;
//# sourceMappingURL=checkbox.js.map

/***/ }),

/***/ 3882:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(1720));
const input_1 = __importDefault(__webpack_require__(8092));
//TODO: remove below lines when btn component is available
const input_styles_1 = __webpack_require__(9142);
const building_blocks_ui_theme_1 = __webpack_require__(549);
const AdrillaInput = (props) => {
    //TODO: use button component when available
    const { theme, currentMode } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = theme.colors[currentMode];
    const submitBtn = (react_1.default.createElement(input_styles_1.SubmitButton, { theme: theme, colors: colors, onClick: props.onBtnClick },
        react_1.default.createElement(input_styles_1.RightArrowIcon, null)));
    const leftElement = react_1.default.createElement(input_styles_1.CarIcon, null);
    return (react_1.default.createElement(input_1.default, Object.assign({}, props, { value: props.value.toUpperCase(), style: { height: '60px' }, leftElement: leftElement, rightElement: submitBtn, isAdrillaInput: true })));
};
exports["default"] = AdrillaInput;
//# sourceMappingURL=home-input.js.map

/***/ }),

/***/ 3367:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(1720));
const input_1 = __importDefault(__webpack_require__(8092));
const Input = (0, react_1.forwardRef)((props, ref) => {
    return react_1.default.createElement(input_1.default, Object.assign({}, props, { ref: ref }));
});
exports["default"] = Input;
//# sourceMappingURL=input.js.map

/***/ }),

/***/ 573:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importDefault(__webpack_require__(1720));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const otpMain_1 = __importDefault(__webpack_require__(6304));
const react_2 = __webpack_require__(1720);
const react_3 = __webpack_require__(1720);
const OTPInput = ({ setIsValidOTP, setOTP, OTP, verifyOTPApiResponse, sendOTPApiResponse, enableAutoReadOTP, isEmailLogin, r2d2, dataTestId, disabled, }) => {
    const [resetOTP, setResetOTP] = (0, react_3.useState)(false);
    (0, react_2.useEffect)(() => {
        if (!OTP) {
            setResetOTP(true);
            setIsValidOTP(false);
        }
        else
            setResetOTP(false);
    }, [OTP]);
    (0, react_2.useEffect)(() => {
        verifyOTPApiResponse.isVerifyOTPError && setResetOTP(true);
    }, [verifyOTPApiResponse.isVerifyOTPError]);
    (0, react_2.useEffect)(() => {
        r2d2 &&
            r2d2({
                ekind: 'otp_screen_loaded',
                edata: {
                    screen: isEmailLogin
                        ? 'email_verification_screen'
                        : 'universal_login_screen',
                    product: isEmailLogin ? 'health_gmc' : undefined,
                },
                okind: 'tracker',
            });
    }, []);
    return (react_1.default.createElement(building_blocks_ui_common_1.Flex, { justifyContent: "center" },
        react_1.default.createElement(otpMain_1.default, { autoFocus: true, isNumberInput: true, length: 4, onChangeOTP: (otp) => {
                setOTP(otp);
                if (otp.length === 4)
                    setIsValidOTP(true);
                else
                    setIsValidOTP(false);
            }, resetOTP: resetOTP, isError: verifyOTPApiResponse.isVerifyOTPError ||
                sendOTPApiResponse.isSendOTPError, enableAutoReadOTP: enableAutoReadOTP, "data-testid": dataTestId, disabled: disabled })));
};
exports["default"] = OTPInput;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4105:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PsuedoDiv = exports.OTPContainer = exports.Input = exports.SampleStyle = void 0;
const building_blocks_ui_common_1 = __webpack_require__(9749);
const responsive_1 = __webpack_require__(3248);
exports.SampleStyle = building_blocks_ui_common_1.styled.div `
  width: 360px;
`;
exports.Input = building_blocks_ui_common_1.styled.input `
  outline: none;
  -webkit-appearance: none;
  width: 60px;
  height: 60px;
  font-size: 16px;
  border-radius: 8px;
  margin-right: 20px;
  border: 1px solid ${(props) => (props.isFocus ? '#696969' : '#E0E0E8')};
  text-align: center;
  @media ${responsive_1.device.mobileS} {
    margin-right: 15px;
  }
  &::placeholder {
    color: #f0f0f6;
    font-size: 20px;
  }
`;
exports.OTPContainer = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) ``;
exports.PsuedoDiv = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  height: 60px;
  width: 30px;
  cursor: text;
  @media ${responsive_1.device.tablet} {
    width: 40px;
  }
`;
//# sourceMappingURL=otpInput.styles.js.map

/***/ }),

/***/ 6304:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.OTPInputComponent = OTPInputComponent;
const react_1 = __importStar(__webpack_require__(1720));
const react_2 = __webpack_require__(1720);
const otpInput_styles_1 = __webpack_require__(4105);
const singleInput_1 = __importDefault(__webpack_require__(3463));
const utils_1 = __webpack_require__(2273);
function OTPInputComponent(props) {
    const { length, isNumberInput, autoFocus, disabled, onChangeOTP, inputClassName, inputStyle, resetOTP, isError, enableAutoReadOTP, dataTestId } = props, rest = __rest(props, ["length", "isNumberInput", "autoFocus", "disabled", "onChangeOTP", "inputClassName", "inputStyle", "resetOTP", "isError", "enableAutoReadOTP", "dataTestId"]);
    const [activeInput, setActiveInput] = (0, react_1.useState)(0);
    const [otpValues, setOTPValues] = (0, react_1.useState)(Array(length).fill(''));
    (0, react_2.useEffect)(() => {
        if (resetOTP) {
            setOTPValues(Array(length).fill(''));
            setActiveInput(0);
        }
    }, [resetOTP]);
    (0, react_2.useEffect)(() => {
        try {
            enableAutoReadOTP &&
                (0, utils_1.autoReadSMS)(otp => {
                    setOTPValues([...otp]);
                    onChangeOTP(otp);
                });
        }
        catch (_a) { }
    }, []);
    // Helper to return OTP from inputs
    const handleOtpChange = (0, react_1.useCallback)((otp) => {
        const otpValue = otp.join('');
        onChangeOTP(otpValue);
    }, [onChangeOTP]);
    // Helper to return value with the right type: 'text' or 'number'
    const getRightValue = (0, react_1.useCallback)((str) => {
        let changedValue = str;
        if (!isNumberInput) {
            return changedValue;
        }
        return !changedValue || /\d/.test(changedValue) ? changedValue : '';
    }, [isNumberInput]);
    // Change OTP value at focussing input
    const changeCodeAtFocus = (0, react_1.useCallback)((str) => {
        const updatedOTPValues = [...otpValues];
        updatedOTPValues[activeInput] = str[0] || '';
        setOTPValues(updatedOTPValues);
        handleOtpChange(updatedOTPValues);
    }, [activeInput, handleOtpChange, otpValues]);
    // Focus `inputIndex` input
    const focusInput = (0, react_1.useCallback)((inputIndex) => {
        const selectedIndex = Math.max(Math.min(length - 1, inputIndex), 0);
        setActiveInput(selectedIndex);
    }, [length]);
    const focusPrevInput = (0, react_1.useCallback)(() => {
        focusInput(activeInput - 1);
    }, [activeInput, focusInput]);
    const focusNextInput = (0, react_1.useCallback)(() => {
        focusInput(activeInput + 1);
    }, [activeInput, focusInput]);
    // Handle onFocus input
    const handleOnFocus = (0, react_1.useCallback)((index) => () => {
        focusInput(index);
    }, [focusInput]);
    // Handle onChange value for each input
    const handleOnChange = (0, react_1.useCallback)((e) => {
        var _a;
        if (((_a = e.currentTarget.value) === null || _a === void 0 ? void 0 : _a.length) > 1) {
            var dataTransfer = new DataTransfer();
            dataTransfer.setData('text/plain', e.currentTarget.value);
            handleOnPaste(new ClipboardEvent('paste', { clipboardData: dataTransfer }));
        }
        else {
            const val = getRightValue(e.currentTarget.value);
            if (!val) {
                e.preventDefault();
                return;
            }
            changeCodeAtFocus(val);
            focusNextInput();
        }
    }, [changeCodeAtFocus, focusNextInput, getRightValue]);
    // Hanlde onBlur input
    const onBlur = (0, react_1.useCallback)(() => {
        setActiveInput(-1);
    }, []);
    // Handle onKeyDown input
    const handleOnKeyDown = (0, react_1.useCallback)((e) => {
        switch (e.key) {
            case 'Backspace':
            case 'Delete': {
                e.preventDefault();
                if (otpValues[activeInput]) {
                    changeCodeAtFocus('');
                }
                else {
                    focusPrevInput();
                }
                break;
            }
            case 'ArrowLeft': {
                e.preventDefault();
                focusPrevInput();
                break;
            }
            case 'ArrowRight': {
                e.preventDefault();
                focusNextInput();
                break;
            }
            case ' ': {
                e.preventDefault();
                break;
            }
            default:
                break;
        }
    }, [activeInput, changeCodeAtFocus, focusNextInput, focusPrevInput, otpValues]);
    const handleOnPaste = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        const pastedData = e.clipboardData
            .getData('text/plain')
            .trim()
            .slice(0, length - activeInput)
            .split('');
        if (pastedData) {
            let nextFocusIndex = 0;
            const updatedOTPValues = [...otpValues];
            updatedOTPValues.forEach((val, index) => {
                if (index >= activeInput) {
                    const changedValue = getRightValue(pastedData.shift() || val);
                    if (changedValue) {
                        updatedOTPValues[index] = changedValue;
                        nextFocusIndex = index;
                    }
                }
            });
            setOTPValues(updatedOTPValues);
            setActiveInput(Math.min(nextFocusIndex + 1, length - 1));
            handleOtpChange(updatedOTPValues);
        }
    }, [activeInput, getRightValue, length, otpValues, handleOtpChange]);
    return (react_1.default.createElement(otpInput_styles_1.OTPContainer, Object.assign({}, rest), Array(length)
        .fill('')
        .map((_, index) => (react_1.default.createElement(singleInput_1.default, { key: index, focus: activeInput === index, value: otpValues && otpValues[index], autoFocus: autoFocus, onFocus: handleOnFocus(index), onChange: handleOnChange, onKeyDown: handleOnKeyDown, onBlur: onBlur, onPaste: handleOnPaste, style: inputStyle, disabled: disabled, isWide: false, index: index, dataTestId: dataTestId })))));
}
exports["default"] = OTPInputComponent;
//# sourceMappingURL=otpMain.js.map

/***/ }),

/***/ 3248:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.device = exports.size = void 0;
exports.size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    laptop: '1024px',
    laptopL: '1440px',
    desktop: '2560px',
};
exports.device = {
    mobileS: `(max-width: ${exports.size.mobileS})`,
    mobileM: `(max-width: ${exports.size.mobileM})`,
    mobileL: `(max-width: ${exports.size.mobileL})`,
    tablet: `(max-width: ${exports.size.tablet})`,
    laptop: `(max-width: ${exports.size.laptop})`,
    laptopL: `(max-width: ${exports.size.laptopL})`,
    desktop: `(max-width: ${exports.size.desktop})`,
    desktopL: `(max-width: ${exports.size.desktop})`,
};
//# sourceMappingURL=responsive.js.map

/***/ }),

/***/ 3463:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SingleOTPInputComponent = SingleOTPInputComponent;
const react_1 = __importStar(__webpack_require__(1720));
const otpInput_styles_1 = __webpack_require__(4105);
const usePrevious_1 = __importDefault(__webpack_require__(5093));
function SingleOTPInputComponent(props) {
    const { focus, autoFocus, value, isWide, index, dataTestId } = props, rest = __rest(props, ["focus", "autoFocus", "value", "isWide", "index", "dataTestId"]);
    const inputRef = (0, react_1.useRef)(null);
    const prevFocus = (0, usePrevious_1.default)(!!focus);
    (0, react_1.useLayoutEffect)(() => {
        if (inputRef.current) {
            if (focus && autoFocus) {
                inputRef.current.focus();
            }
            if (focus && autoFocus && focus !== prevFocus) {
                inputRef.current.focus();
                inputRef.current.select();
            }
        }
    }, [autoFocus, focus, prevFocus]);
    return (react_1.default.createElement(otpInput_styles_1.Input, Object.assign({ autoComplete: index === 0 ? 'one-time-code' : '', ref: inputRef }, rest, { isFocus: focus, value: value, isWide: isWide, type: "tel", placeholder: "\u25CF", "data-testid": dataTestId })));
}
exports["default"] = SingleOTPInputComponent;
//# sourceMappingURL=singleInput.js.map

/***/ }),

/***/ 5093:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(1720);
function usePrevious(value) {
    const ref = (0, react_1.useRef)();
    // Store current value in ref
    (0, react_1.useEffect)(() => {
        ref.current = value;
    }, [value]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
}
exports["default"] = usePrevious;
//# sourceMappingURL=usePrevious.js.map

/***/ }),

/***/ 2273:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.autoReadSMS = autoReadSMS;
function autoReadSMS(cb) {
    // used AbortController with setTimeout so that WebOTP API (Autoread sms) will get disabled after 1min
    const signal = new AbortController();
    setTimeout(() => {
        signal.abort();
    }, 1 * 60 * 1000);
    function main() {
        return __awaiter(this, void 0, void 0, function* () {
            if ('OTPCredential' in window) {
                try {
                    if (navigator.credentials) {
                        try {
                            yield navigator.credentials
                                .get({ abort: signal, otp: { transport: ['sms'] } })
                                .then((content) => {
                                if (content && content.code) {
                                    cb(content.code);
                                }
                            })
                                .catch(e => console.log(e));
                        }
                        catch (e) {
                            return;
                        }
                    }
                }
                catch (err) {
                    console.log(err);
                }
            }
        });
    }
    main();
}
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 7961:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(1720));
const input_1 = __importDefault(__webpack_require__(8092));
const input_styles_1 = __webpack_require__(9142);
const PasswordInput = (props) => {
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    function changeType() {
        setShowPassword(!showPassword);
    }
    function getPasswordIcon() {
        return showPassword ? (react_1.default.createElement(input_styles_1.ShowPasswordIcon, { onClick: changeType })) : (react_1.default.createElement(input_styles_1.HidePasswordIcon, { onClick: changeType }));
    }
    function rightElem() {
        return props.value ? getPasswordIcon() : null;
    }
    return (react_1.default.createElement(input_1.default, Object.assign({}, props, { type: showPassword ? 'text' : 'password', rightElement: rightElem() })));
};
exports["default"] = PasswordInput;
//# sourceMappingURL=password.js.map

/***/ }),

/***/ 319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
//@ts-nocheck
const react_1 = __importStar(__webpack_require__(1720));
const input_1 = __importDefault(__webpack_require__(8092));
const building_blocks_ui_acko_analytics_1 = __webpack_require__(4262);
const helpers_1 = __importDefault(__webpack_require__(1371));
// TODO - move to uitls -
// const emailRegex = '^[w-.]+@([w-]+.)+[w-]{2,4}$';
const emailRegexp = new RegExp(/^[a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1}([a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1})*[a-zA-Z0-9]@[a-zA-Z0-9][-\.]{0,1}([a-zA-Z][-\.]{0,1})*[a-zA-Z0-9]\.[a-zA-Z0-9]{1,}([\.\-]{0,1}[a-zA-Z]){0,}[a-zA-Z0-9]{0,}$/i);
const phoneRegex = new RegExp('^[6-9][0-9]{9}$', 'i');
const PHONE = 'phone';
const EMAIL = 'email';
const PhoneEmailInput = (_a) => {
    var { setParentInputType, setParentErrorStatus, setParentInputValue } = _a, props = __rest(_a, ["setParentInputType", "setParentErrorStatus", "setParentInputValue"]);
    const [touched, setTouched] = (0, react_1.useState)(false);
    const [hasError, setHasError] = (0, react_1.useState)(true);
    const [errorMsg, setErrorMsg] = (0, react_1.useState)('');
    const [inputValue, setInputValue] = (0, react_1.useState)('');
    const [inputEventSent, setInputEventSent] = (0, react_1.useState)(false);
    const handleValidation = () => {
        let errors = '';
        if (!inputValue) {
            setHasError(true);
            errors = 'This field is required';
        }
        else if (phoneRegex.test(inputValue)) {
            setParentInputType(PHONE);
            !inputEventSent && (0, building_blocks_ui_acko_analytics_1.trackEvent)('enter_phone_number_before_clicking_continue', { communication_phone: inputValue });
            setHasError(false);
            setInputEventSent(true);
        }
        else if (emailRegexp.test(inputValue)) {
            setParentInputType(EMAIL);
            !inputEventSent && (0, building_blocks_ui_acko_analytics_1.trackEvent)('enter_email_id_before_clicking_continue', { communication_email: inputValue });
            setHasError(false);
            setInputEventSent(true);
        }
        else {
            setHasError(true);
            errors = 'Please provide a valid Email or phone number';
        }
        setErrorMsg(errors);
    };
    const handleOnChange = (e) => {
        setInputValue(e.target.value);
        setParentInputValue(e.target.value);
    };
    (0, react_1.useEffect)(() => {
        (0, helpers_1.default)(() => { handleValidation(); }, 1000)();
    }, [inputValue]);
    (0, react_1.useEffect)(() => {
        console.log('has errror....', hasError);
        setParentErrorStatus(hasError);
    }, [hasError]);
    return (react_1.default.createElement(input_1.default, { labelText: "Email or mobile number", hasError: hasError && touched, errMsg: errorMsg, onChange: handleOnChange, onBlur: () => {
            setTouched(true);
            handleValidation();
        }, value: inputValue, type: "text", className: "", name: "phoneEmail" }));
};
exports["default"] = PhoneEmailInput;
//# sourceMappingURL=phone-email-input.js.map

/***/ }),

/***/ 4186:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(1720));
const input_1 = __importDefault(__webpack_require__(8092));
const input_styles_1 = __webpack_require__(9142);
const building_blocks_ui_theme_1 = __webpack_require__(549);
const ErrorMap = {
    EMPTY_ERROR: 'This field is required',
    INVALID_PHONE: 'Enter a valid phone number',
};
const phoneRegex = new RegExp('^[6-9][0-9]{9}$', 'i');
const PhoneInput = (props) => {
    const [inputValue, setInputValue] = (0, react_1.useState)('');
    const [hasError, setHasError] = (0, react_1.useState)(true);
    const [errorMsg, setErrorMsg] = (0, react_1.useState)('');
    const [touched, setTouched] = (0, react_1.useState)(false);
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    const handleOnChange = (event) => {
        setInputValue(`${event.target.value}`);
    };
    const handleValidation = () => {
        let errors = '';
        if (!inputValue) {
            setHasError(true);
            errors = ErrorMap.EMPTY_ERROR;
        }
        else if (phoneRegex.test(inputValue)) {
            setHasError(false);
        }
        else {
            setHasError(true);
            errors = ErrorMap.INVALID_PHONE;
        }
        if (errors && props.onError) {
            props.onError(inputValue, errors);
        }
        setErrorMsg(errors);
    };
    (0, react_1.useEffect)(() => {
        handleValidation();
    }, [inputValue]);
    return (react_1.default.createElement(input_1.default, Object.assign({}, props, { value: inputValue, onChange: handleOnChange, hasError: hasError && touched, errMsg: errorMsg, onBlur: () => {
            setTouched(true);
            handleValidation();
        }, leftElement: react_1.default.createElement(input_styles_1.CountryCodeText, { theme: theme, colors: colors }, "+91") })));
};
exports["default"] = PhoneInput;
//# sourceMappingURL=phone-input.js.map

/***/ }),

/***/ 1969:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_theme_1 = __webpack_require__(549);
const react_1 = __importDefault(__webpack_require__(1720));
const input_styles_1 = __webpack_require__(9142);
const Radio = (props) => {
    const { dimension = "small", checked, onChange = () => { } } = props;
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    return (react_1.default.createElement(input_styles_1.CheckBoxElement, { type: "radio", checked: checked, onClick: onChange, theme: theme, colors: colors, dimension: dimension }));
};
exports["default"] = Radio;
//# sourceMappingURL=radio.js.map

/***/ }),

/***/ 4592:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_theme_1 = __webpack_require__(549);
const react_1 = __importDefault(__webpack_require__(1720));
const input_styles_1 = __webpack_require__(9142);
const Toggle = (props) => {
    const { type, checked, onChange = () => { } } = props;
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    return (react_1.default.createElement(input_styles_1.ToggleElement, { colors: colors, theme: theme },
        react_1.default.createElement("input", { type: type, id: "switch", className: "checkbox", checked: checked, onChange: onChange }),
        react_1.default.createElement("label", { htmlFor: "switch", className: "toggle" })));
};
exports["default"] = Toggle;
//# sourceMappingURL=toggle.js.map

/***/ }),

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 4150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D6": function() { return /* binding */ emailValidation; },
/* harmony export */   "Vw": function() { return /* binding */ panValidation; },
/* harmony export */   "ee": function() { return /* binding */ gstPanValidation; },
/* harmony export */   "q$": function() { return /* binding */ phoneNumberValidation; },
/* harmony export */   "sU": function() { return /* binding */ gstValidation; },
/* harmony export */   "xz": function() { return /* binding */ inputRegexValidation; }
/* harmony export */ });
/* unused harmony export DEFAULT_COUNTRY_CODE */
function inputRegexValidation(text) {
    try {
        if (text.length === 0) {
            return false;
        }
        var regx = /<|\/\/|>|<iframe|http:|https:/g;
        if (regx.test(text) || /\$/.test(text)) {
            return false;
        }
        return true;
    } catch (e) {
        return false;
    }
}
/** Default country code for phone validation (aligned with backend ProcessingConstants.DEFAULT_COUNTRY_CODE) */ var DEFAULT_COUNTRY_CODE = "IN";
/**
 * Validates phone number for default country (IN). Mirrors backend MobileNumberValidator:
 * - Empty → valid
 * - Length !== 10 → invalid
 * - For IN: 10 digits, mobile must start with 6, 7, 8 or 9 (isPossibleNumber semantics)
 */ function phoneNumberValidation(phoneNumber) {
    if (phoneNumber == null || phoneNumber.length === 0) {
        return true;
    }
    if (phoneNumber.length !== 10) {
        return false;
    }
    // IN mobile: exactly 10 digits, no spaces; leading digit 6–9 (possible Indian mobile)
    return /^[6-9]\d{9}$/.test(phoneNumber);
}
function emailValidation(email) {
    if (email.length === 0) return false;
    // Reject emails containing any whitespace (e.g. "user @gmail.com")
    if (/\s/.test(email)) return false;
    var regex1 = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@" + "[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?" + "(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$");
    var regex2 = /.+@.+\..+/;
    return regex1.test(email) && regex2.test(email);
}
function panValidation(panNumber) {
    try {
        var regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        return regpan.test(panNumber);
    } catch (e) {
        return false;
    }
}
function gstValidation(gstNumber) {
    try {
        var regGst = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        return regGst.test(gstNumber);
    } catch (e) {
        return false;
    }
}
function gstPanValidation(gstNumber, panNumber, gstApplicable) {
    try {
        if (!gstApplicable) {
            return true;
        }
        if (!gstNumber || gstNumber.length === 0) return false;
        if (!gstValidation(gstNumber)) {
            return false;
        }
        var gstPan = gstNumber.substring(2, 12);
        return gstPan === panNumber;
    } catch (e) {
        return false;
    }
}


/***/ }),

/***/ 4850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ otp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.input/dist/index.js
var dist = __webpack_require__(3282);
// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
// EXTERNAL MODULE: ./library/snackbar/index.tsx + 1 modules
var library_snackbar = __webpack_require__(6241);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var building_blocks_ui_common_dist = __webpack_require__(9749);
;// CONCATENATED MODULE: ./widgets/otp/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 30px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n    margin-top: 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 8px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #5b5675;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-left: 5px;\n    align-items: center;\n    margin-top: 5px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 32px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 22px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    align-items: center;\n    color: #5b5675;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 22px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    align-items: center;\n    color: #1b73e8;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var Wrapper = building_blocks_ui_common_dist.styled.div(_templateObject());
var Header = building_blocks_ui_common_dist.styled.div(_templateObject1());
var BackArrowIcon = building_blocks_ui_common_dist.styled.div(_templateObject2());
var OTPImageWrapper = building_blocks_ui_common_dist.styled.div(_templateObject3());
var VerificationCodeText = building_blocks_ui_common_dist.styled.div(_templateObject4());
var OTPTextMessageWrapper = building_blocks_ui_common_dist.styled.div(_templateObject5());
var OTPTextMessage = building_blocks_ui_common_dist.styled.div(_templateObject6());
var EditIcon = building_blocks_ui_common_dist.styled.div(_templateObject7());
var OTPInputWrapper = building_blocks_ui_common_dist.styled.div(_templateObject8());
var ResendOTPText = building_blocks_ui_common_dist.styled.div(_templateObject9());
var ResendLinkText = building_blocks_ui_common_dist.styled.div(_templateObject10());

;// CONCATENATED MODULE: ./widgets/otp/index.tsx











function OTP(param) {
    var phoneNumber = param.phoneNumber, onClickEdit = param.onClickEdit, onClickBack = param.onClickBack, onSuccess = param.onSuccess;
    var ref = (0,compat_module.useState)(""), _$OTP = ref[0], setOTP = ref[1];
    var ref1 = (0,compat_module.useState)(30), timer = ref1[0], setTimer = ref1[1];
    var ref2 = (0,compat_module.useState)(false), isValidOTP = ref2[0], setIsValidOTP = ref2[1];
    var ref3 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref3[0], setSnackbar = ref3[1];
    (0,compat_module.useEffect)(function() {
        var intervalId;
        if (timer > 0) {
            intervalId = setInterval(function() {
                setTimer(timer - 1);
            }, 1000);
        }
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        timer
    ]);
    (0,compat_module.useEffect)(function() {
        if (isValidOTP) {
            __webpack_require__.e(/* import() */ 219).then(__webpack_require__.bind(__webpack_require__, 7219)).then(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
                    var ref, status, errMsg;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    req.verifyOTP(_$OTP, phoneNumber)
                                ];
                            case 1:
                                ref = _state.sent(), status = ref.status, errMsg = ref.errMsg;
                                if (status) {
                                    onSuccess();
                                    return [
                                        2
                                    ];
                                }
                                setSnackbar({
                                    type: "failure",
                                    message: errMsg || "Invalid OTP."
                                });
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(req) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    }, [
        isValidOTP
    ]);
    var resendOTP = function() {
        __webpack_require__.e(/* import() */ 219).then(__webpack_require__.bind(__webpack_require__, 7219)).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
                var ref, status, errMsg;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                req.resendOTP(phoneNumber)
                            ];
                        case 1:
                            ref = _state.sent(), status = ref.status, errMsg = ref.errMsg;
                            if (status) {
                                setTimer(30);
                                return [
                                    2
                                ];
                            }
                            setSnackbar({
                                type: "failure",
                                message: errMsg || "Something went wrong. Please try again"
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(req) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Header, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BackArrowIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        width: "10px",
                        height: "24px",
                        alt: "",
                        src: (0,generics/* getImageBasePath */.m4)("/icons/backArrow.svg"),
                        onClick: onClickBack
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(OTPImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "80px",
                    height: "80px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/otp.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(VerificationCodeText, {
                children: "Enter verification code"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(OTPTextMessageWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(OTPTextMessage, {
                        children: [
                            "OTP has been sent to ",
                            phoneNumber
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EditIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "16px",
                            height: "16px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/blueEdit.svg"),
                            onClick: onClickEdit
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(OTPInputWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.OTPInput, {
                    OTP: _$OTP,
                    setOTP: function(otp) {
                        return setOTP(otp);
                    },
                    setIsValidOTP: function(status) {
                        return setIsValidOTP(status);
                    },
                    verifyOTPApiResponse: {
                        isVerifyOTPError: false,
                        errorMessage: ""
                    },
                    sendOTPApiResponse: {
                        isSendOTPError: false,
                        errorMessage: ""
                    },
                    dataTestId: ""
                })
            }),
            timer === 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ResendLinkText, {
                onClick: resendOTP,
                children: "Resend OTP"
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ResendOTPText, {
                children: [
                    "Resend OTP in 00:",
                    timer > 9 ? timer : "0".concat(timer)
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, snackbar), {
                handleSnakbarComplete: function() {
                    return setSnackbar({
                        type: "",
                        message: ""
                    });
                }
            }))
        ]
    });
}
/* harmony default export */ var otp = (OTP);


/***/ })

}]);